import { Injectable } from '@angular/core';
import { AppStoreQuery } from '@core/state';

import { UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PendingAreaGuard {
  user = this.query.selectUser();
  constructor(private query: AppStoreQuery) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.query.selectUser().pipe(map((user) => !user?.isRestrictedUser));
  }
}
